import GridBackground from '@/components/GridBackground';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import WhatsAppFloatButton from '@/components/WhatsAppFloatButton';

export default function LocaleShell({ children, after }) {
  return (
    <div className="min-h-screen bg-background text-foreground relative">
      <GridBackground />
      <Navbar />
      <main className="relative z-10 max-w-4xl mx-auto px-6 lg:px-8 pt-36 pb-12">{children}</main>
      {after}
      <Footer />
      <WhatsAppFloatButton />
    </div>
  );
}